/**
 * HTML creation / modification functions.
 */

/**
 * Build an HTML string based from a tag name, its' inner html and its attributes.
 * Null or undefined attributes will not be included
 *
 * Example usage:
 *
 * buildHtmlString({
 *     elementType: 'div',
 *     innerHtml: 'Content inside the div',
 *     attributes: {
 *         'class': 'pretty',
 *         'onclick': 'doStuff(),
 *         'ignore': null
 *     }
 * });
 *
 * will output the following HTML:
 *
 * <div class="pretty" onclick="doStuff()">Content inside the div</div>
 */

export const buildHtmlString = ({
  elementType,
  innerHtml,
  attributes,
}: {
  elementType: string;
  innerHtml: string;
  attributes: Record<string, string | boolean | number | null | undefined>;
}): string => {
  const attributeString = Object.entries(attributes)
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `<${elementType} ${attributeString}>${innerHtml}</${elementType}>`;
};
